export default __webpack_public_path__ + "assets/img/profile.8c421f27.png";